export enum LOCAL_STORAGE {
    TOKEN = "token",
    USER_DETAILS = "userData",
    STAY_SIGNED_IN = "staySignedIn",

    STAY_LOGGED_IN = "STAY_LOGGED_IN",
} 

export enum ROLE {
    AUDIENCE = "AUDIENCE",
    ARTIST = "ARTIST",
    GUEST = "GUEST"
}


export const AVAILABLE_COUNTRY_CODES = [
    // '+1',      // US
    '+1',      // CA
    '+91',     // IN
    '+44',     // GB
    '+354',    // IS
    '+353',    // IE
    '+47',     // NO
    '+358',    // FI
    '+46',     // SE
    '+45',     // DK
    '+48',     // PL
    '+33',     // FR
    '+41',     // CH
    '+31',     // NL
    '+34',     // ES
    '+39',     // IT
    '+351',    // PT
    '+30',     // GR
    '+385'     // HR
  ];
